/*
 * CH market: Swiss money formatting (apostrophe thousands separator + no "CHF" prefix, e.g. 6'620.00).
 *
 * Several apps re-render prices client-side from window.theme.moneyFormat ("CHF {{amount}}"), which we
 * cannot make Swiss via a money-format token (the consumers don't support {{amount_with_apostrophe_separator}}).
 * So instead of touching window.theme, we rewrite the rendered price TEXT after each render, for:
 *   - [data-live-price]              Dawn price.liquid main price (re-rendered by Live Product Options)
 *   - .config-price                  Live Product Options option-button price deltas
 *   - .price-delivery                delivery price display
 *   - gp-product-price / .gp-money   GemPages prices
 *
 * Cart prices are NOT handled here: the cart is server-rendered (incl. Section Rendering API
 * updates), so it is formatted in Liquid via snippets/money-market.liquid instead.
 *
 * "CHF 6,620.00" -> "6'620.00". Idempotent (re-running is a no-op).
 * Loaded only on the CH market (gated in layout/theme.liquid).
 */
(function () {
  function toSwiss(s) {
    return s
      .replace(/\d{1,3}(?:,\d{3})+/g, function (m) { return m.replace(/,/g, "'"); })
      .replace(/CHF\s*/g, '');
  }
  function fixNode(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), n;
    while ((n = walker.nextNode())) {
      var v = n.nodeValue;
      if (v && /\d/.test(v) && (v.indexOf(',') !== -1 || v.indexOf('CHF') !== -1)) {
        var nv = toSwiss(v);
        if (nv !== v) n.nodeValue = nv;
      }
    }
  }
  function fix() {
    var els = document.querySelectorAll('gp-product-price, .gp-money, .config-price, .price-delivery, [data-live-price]');
    for (var i = 0; i < els.length; i++) fixNode(els[i]);
  }
  var observer, scheduled = false;
  function run() {
    observer.disconnect();        // don't record our own writes
    fix();
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; run(); });
  }
  function start() {
    observer = new MutationObserver(schedule);
    run();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
